export const jobs = [
  {
    'name': 'Google',
    'start': 'September 2021',
    'end': 'present',
    'location': 'Chicago, IL',
    'title': 'Software Engineer',
    'description': 'Google Search on Desktop Web Team'
  },
  {
    'name': 'Pivotal Labs',
    'start': 'September 2017',
    'end': 'September 2021',
    'location': 'Chicago, IL',
    'title': 'Senior Software Engineer',
    'list': [
      'Partnered with client teams to co-create software. Built web applications, event driven microservices, mapping tools, and DevOps automation engines',
      'Lead architectural efforts and technical side of teams',
      'Enabled client teams to operate as an effective product team using XP and Lean Practices',
      'Collaborated closely with Product Mangers, Product Designers and business stakeholders',
      'Taught Cloud Native Development (Java/Spring) courses to developers and architects',
      'Worked with clients in industries ranging from Banking, Credit Card, Tech, Aerospace, Insurance, and Military'
    ]
  },
  {
    'name': 'Expedia Inc.',
    'start': 'June 2016',
    'end': 'August 2016',
    'location': 'Chicago, IL',
    'title': 'Software Development Engineering Intern',
    'description': 'Software Development Engineering Intern. Worked as part of the travel packages team on Expedia’s core codebase. Used the following technologies: Java, Spring, FTLs, Handlebars, Ember, Backbone, Less, Perforce.'
  },
  {
    'name': 'Level 3 Communications',
    'start': 'June 2015',
    'end': 'September 2015',
    'location': 'Boulder, CO',
    'title': 'Software Development Intern',
    'description': 'Worked as part of a team to develop an In-House application. Primarily worked with Angular.JS and Java(Spring Framework). Also worked with Oracle SQL and git.'
  },
  {
    'name': 'Encision Inc.',
    'start': 'June 2014',
    'end': 'April 2015',
    'location': 'Boulder, CO',
    'title': 'Marketing Intern',
    'description': 'Wrote, filmed, produced, and edited multiple product videos, created centralized database for company sales force, created and distributed launch books for a new product, assisted Encision co-founder and VP of Technology with lab research.'
  },
  {
    'name': 'Studio N',
    'start': 'December 2013',
    'end': 'Present',
    'location': 'Evanston, IL',
    'title': 'Camera operator, Control Room Technician',
    'description': 'Operated camera and worked in Tech Booth to produce and stream live NCAA sporting events over the Internet.'
  },
  {
    'name': 'GEOS Global Synergy Funds',
    'start': 'May 2013',
    'end': 'August 2014',
    'location': 'Boulder, CO',
    'title': 'Office Intern',
    'description': 'Worked as an Intern preforming office tasks, conducting research, confirming trades, and assisting the back office.'
  }
];

